import { Container } from "pixi.js";
import { SpriteText, SpriteTextFitMode, WinAmountLabelFlare } from "@slot/presentation";
import type { SpriteFontDefinition } from "@slot/presentation";

/** `GridSymbolWinAmountLabel.prefab`: the `wooden-numbers` digits at glyph scale 0.55, shrunk to fit their box. */
const LABEL = { maxCharacters: 45, glyphScale: 0.55, box: { width: 424.9, height: 134.9 } } as const;

/**
 * Builds one win-amount label (the prefab's tree): the sprite-font amount under the flare variant (it pops in big,
 * settles and flares). `WinHighlightEffect` calls this per label and destroys the result.
 */
export function createWinAmountLabelFactory(input: { font: SpriteFontDefinition }): () => WinAmountLabelFlare {
  return () => {
    const root = new Container({ label: "GridSymbolWinAmountLabel" });
    const spriteText = new SpriteText({
      font: input.font,
      maxCharacters: LABEL.maxCharacters,
      glyphScale: LABEL.glyphScale,
      fitMode: SpriteTextFitMode.Both,
      boxWidth: LABEL.box.width,
      boxHeight: LABEL.box.height,
      label: "SpriteTextLabel",
    });
    root.addChild(spriteText);
    return new WinAmountLabelFlare({ node: root, spriteText });
  };
}
